module.exports = __webpack_public_path__ + "f75e09918296c8490a98505fb5f28452.svg";